const quesReducer = (data = [], action) => {	
  if (action.type === 'FETCH_MY_QUES_LIST') {
    return action.payload;
  }
  return data;
};

export default quesReducer